export { default } from "ember-simple-auth/utils/inject";
